import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/lib/auth-store";
import { ThemeProvider } from "@/lib/theme";
import { GTMScript } from "@/components/GTMScript";
import { lazy, Suspense } from "react";
import { AppRoutes } from "@/routes";

const CookieConsent = lazy(() => import("@/components/CookieConsent").then(m => ({ default: m.CookieConsent })));
const AdminToaster = lazy(() => import("sonner").then(m => ({ default: m.Toaster })));
import Home from "@/pages/Home";
import NotFound from "@/pages/not-found";

const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const DynamicPage = lazy(() => import("@/pages/DynamicPage"));
const Admin = lazy(() => import("@/pages/Admin"));
const AdminCMS = lazy(() => import("@/pages/AdminCMS"));
const AdminData = lazy(() => import("@/pages/AdminData"));
const AdminCoverFinder = lazy(() => import("@/pages/AdminCoverFinder"));
const AdminAnalytics = lazy(() => import("@/pages/AdminAnalytics"));
const AdminReports = lazy(() => import("@/pages/AdminReports"));
const AdminAdvertising = lazy(() => import("@/pages/AdminAdvertising"));
const Login = lazy(() => import("@/pages/Login"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const Contact = lazy(() => import("@/pages/Contact"));
const CoverFinder = lazy(() => import("@/pages/CoverFinder"));
const JoinPanel = lazy(() => import("@/pages/JoinPanel"));
const CarInsurance = lazy(() => import("@/pages/CarInsurance"));
const TagPage = lazy(() => import("@/pages/TagPage"));
const SoroArticle = lazy(() => import("@/pages/SoroArticle"));
const toastRoutes = new Set(["/admin", "/cms", "/advertising"]);

function Router() {
  return AppRoutes({
    Home,
    Blog,
    SoroArticle,
    BlogPost,
    LegalPage,
    Contact,
    CoverFinder,
    JoinPanel,
    CarInsurance,
    TagPage,
    DynamicPage,
    Admin,
    AdminCMS,
    AdminData,
    AdminCoverFinder,
    AdminAnalytics,
    AdminReports,
    AdminAdvertising,
    Login,
    NotFound,
  });
}

function App() {
  const [location] = useLocation();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TooltipProvider>
            <GTMScript />
            {toastRoutes.has(location) && (
              <Suspense fallback={null}>
                <AdminToaster />
              </Suspense>
            )}
            <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
              <Router />
              <CookieConsent />
            </Suspense>
          </TooltipProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
